import React, { useEffect } from 'react';
import Hero from '../Hero/Hero';
import About from '../About/About';
import Skill from '../Skill/Skill';
import Education from '../Education/Education';
import Footer from '../Footer/Footer';
import Contact from '../Contact/Contact';
import Team from '../Team/Team';
import Meet from '../Meet/Meet';
import Navbar from '../Navbar/Navbar';
import Work from '../Work/Work';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Blog from '../Blog/Blog';

const Layout = () => {

    useEffect(() => {
        AOS.init();
      }, [])
    return (
        <div>
            <Navbar></Navbar>
            <Hero></Hero>
            <About></About>
            <Skill></Skill>
            <Education></Education>
            <Team></Team>
            <Blog></Blog>
            <Work></Work>
            <Meet></Meet>
            <Contact></Contact>
            <Footer></Footer>
           
 
        </div>
    );
};

export default Layout;